export const EXPERIMENT_KEYS = {
  AB_SETUP_TEST_953_01: '953_01_AB_Setup_Test',
  VARIANT: 'variant',
} as const;
